import React, { useState } from 'react';
import { ShipmentData } from '../../lib/supabase';

interface ShipmentFormProps {
  onSubmit: () => void;
  initialData?: ShipmentData;
}

const ShipmentForm: React.FC<ShipmentFormProps> = ({ onSubmit, initialData }) => {
  const [formData, setFormData] = useState({
    bl_number: initialData?.bl_number || '',
    shipping_line: initialData?.shipping_line || '',
    customer: initialData?.customer || '',
    origin: initialData?.origin || '',
    destination: initialData?.destination || '',
    vessel: initialData?.vessel || '',
    voyage: initialData?.voyage || '',
    departure_date: initialData?.departure_date ? new Date(initialData.departure_date).toISOString().split('T')[0] : '',
    estimated_arrival: initialData?.estimated_arrival ? new Date(initialData.estimated_arrival).toISOString().split('T')[0] : '',
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div>
          <label htmlFor="bl_number" className="block text-sm font-medium text-gray-700">
            Bill of Lading Number
          </label>
          <input
            type="text"
            id="bl_number"
            value={formData.bl_number}
            onChange={(e) => setFormData({ ...formData, bl_number: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
            required
          />
        </div>

        <div>
          <label htmlFor="shipping_line" className="block text-sm font-medium text-gray-700">
            Shipping Line
          </label>
          <input
            type="text"
            id="shipping_line"
            value={formData.shipping_line}
            onChange={(e) => setFormData({ ...formData, shipping_line: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
            required
          />
        </div>

        <div>
          <label htmlFor="customer" className="block text-sm font-medium text-gray-700">
            Customer
          </label>
          <input
            type="text"
            id="customer"
            value={formData.customer}
            onChange={(e) => setFormData({ ...formData, customer: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
            required
          />
        </div>

        <div>
          <label htmlFor="origin" className="block text-sm font-medium text-gray-700">
            Origin
          </label>
          <input
            type="text"
            id="origin"
            value={formData.origin}
            onChange={(e) => setFormData({ ...formData, origin: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
            required
          />
        </div>

        <div>
          <label htmlFor="destination" className="block text-sm font-medium text-gray-700">
            Destination
          </label>
          <input
            type="text"
            id="destination"
            value={formData.destination}
            onChange={(e) => setFormData({ ...formData, destination: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
            required
          />
        </div>

        <div>
          <label htmlFor="vessel" className="block text-sm font-medium text-gray-700">
            Vessel
          </label>
          <input
            type="text"
            id="vessel"
            value={formData.vessel}
            onChange={(e) => setFormData({ ...formData, vessel: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
            required
          />
        </div>

        <div>
          <label htmlFor="voyage" className="block text-sm font-medium text-gray-700">
            Voyage
          </label>
          <input
            type="text"
            id="voyage"
            value={formData.voyage}
            onChange={(e) => setFormData({ ...formData, voyage: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
            required
          />
        </div>

        <div>
          <label htmlFor="departure_date" className="block text-sm font-medium text-gray-700">
            Departure Date
          </label>
          <input
            type="date"
            id="departure_date"
            value={formData.departure_date}
            onChange={(e) => setFormData({ ...formData, departure_date: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
          />
        </div>

        <div>
          <label htmlFor="estimated_arrival" className="block text-sm font-medium text-gray-700">
            Estimated Arrival
          </label>
          <input
            type="date"
            id="estimated_arrival"
            value={formData.estimated_arrival}
            onChange={(e) => setFormData({ ...formData, estimated_arrival: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
          />
        </div>
      </div>

      <div className="flex justify-end space-x-3">
        <button
          type="button"
          onClick={() => onSubmit()}
          className="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default ShipmentForm;